var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "padd30 seller-style thirdparty" },
    [
      _c("h2", { staticClass: "f18 gray_3 bor_b pad20_b mar20-b" }, [
        _vm._v("三方订单同步")
      ]),
      _c(
        "el-form",
        {
          ref: "searchForm",
          attrs: { "label-suffix": "：", inline: "", model: _vm.searchForm }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "商城订单生成日期" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "value-format": "yyyy-MM-dd"
                },
                model: {
                  value: _vm.date,
                  callback: function($$v) {
                    _vm.date = $$v
                  },
                  expression: "date"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "orderId", label: "按订单号查询" } },
            [
              _c("el-input", {
                staticStyle: { width: "270px" },
                attrs: {
                  placeholder: "请输入商城订单号或三方平台订单号",
                  clearable: ""
                },
                model: {
                  value: _vm.searchForm.orderId,
                  callback: function($$v) {
                    _vm.$set(_vm.searchForm, "orderId", $$v)
                  },
                  expression: "searchForm.orderId"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "orderStatus", label: "商城订单状态" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "150px" },
                  attrs: { placeholder: "全部", clearable: "" },
                  model: {
                    value: _vm.searchForm.orderStatus,
                    callback: function($$v) {
                      _vm.$set(_vm.searchForm, "orderStatus", $$v)
                    },
                    expression: "searchForm.orderStatus"
                  }
                },
                _vm._l(_vm.statusList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.description, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "goodsName", label: "货品名称" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入商城订单货品名称", clearable: "" },
                model: {
                  value: _vm.searchForm.goodsName,
                  callback: function($$v) {
                    _vm.$set(_vm.searchForm, "goodsName", $$v)
                  },
                  expression: "searchForm.goodsName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "syncStatus", label: "三方订单同步状态" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "150px" },
                  attrs: { placeholder: "全部", clearable: "" },
                  model: {
                    value: _vm.searchForm.syncStatus,
                    callback: function($$v) {
                      _vm.$set(_vm.searchForm, "syncStatus", $$v)
                    },
                    expression: "searchForm.syncStatus"
                  }
                },
                _vm._l(_vm.syncStatusList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.description, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.searchSubmit } },
                [_vm._v("查询")]
              ),
              _c("el-button", { on: { click: _vm.searchReset } }, [
                _vm._v("重置")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { "min-height": "600px" }
        },
        [
          _vm.list && _vm.list.length
            ? _c(
                "el-row",
                {
                  attrs: {
                    "element-loading-custom-class": "seller-style",
                    gutter: 20
                  }
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-card",
                        { staticClass: "box-card", attrs: { shadow: "none" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "clearfix",
                              attrs: { slot: "header" },
                              slot: "header"
                            },
                            [
                              _c("div", { staticClass: "text-center f16 fb" }, [
                                _vm._v("商城订单信息")
                              ])
                            ]
                          ),
                          _vm._l(_vm.list, function(item) {
                            return _c(
                              "el-card",
                              {
                                key: item.orderId,
                                staticClass: "box-card mar15-b"
                              },
                              [
                                _c("div", { staticClass: "flex" }, [
                                  _c("div", { staticClass: "flex-auto" }, [
                                    _c(
                                      "div",
                                      { staticClass: "text mar10-b item" },
                                      [
                                        _vm._v(
                                          "订单编号: " + _vm._s(item.orderId)
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "text mar10-b item" },
                                      [
                                        _vm._v(
                                          "下单时间: " + _vm._s(item.orderTime)
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "text mar10-b item" },
                                      [
                                        _vm._v(
                                          "订单金额: " +
                                            _vm._s(item.orderTotalPrice)
                                        )
                                      ]
                                    ),
                                    _c("div", { staticClass: "text item" }, [
                                      _vm._v(
                                        "订单状态: " +
                                          _vm._s(item.orderStatusCn)
                                      )
                                    ])
                                  ]),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-right",
                                      attrs: {
                                        href: "/v/order/detail/" + item.orderId,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "medium"
                                          }
                                        },
                                        [_vm._v("查看订单")]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-card",
                        { staticClass: "box-card", attrs: { shadow: "none" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "clearfix",
                              attrs: { slot: "header" },
                              slot: "header"
                            },
                            [
                              _c("div", { staticClass: "text-center f16 fb" }, [
                                _vm._v("三方平台同步订单信息")
                              ])
                            ]
                          ),
                          _vm._l(_vm.list, function(item) {
                            return _c(
                              "el-card",
                              {
                                key: item.orderId,
                                staticClass: "box-card mar15-b min-height"
                              },
                              [
                                _c("div", { staticClass: "flex" }, [
                                  _c(
                                    "div",
                                    { staticClass: "flex-auto" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "text flex mar10-b item"
                                        },
                                        [
                                          _c("div", [_vm._v("同步状态:")]),
                                          _c(
                                            "el-link",
                                            {
                                              staticClass: "mar10-l state",
                                              attrs: {
                                                underline: false,
                                                type:
                                                  item.syncStatus == "1"
                                                    ? "success"
                                                    : item.syncStatus == "2" ||
                                                      item.syncStatus == "3"
                                                    ? "danger"
                                                    : "primary"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(item.syncStatusCn) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      item.syncStatus == "1"
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text mar10-b item"
                                              },
                                              [
                                                _vm._v(
                                                  "订单编号: " +
                                                    _vm._s(
                                                      item.thirdPartyOrderNo
                                                    )
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text mar10-b item"
                                              },
                                              [
                                                _vm._v(
                                                  "下单时间: " +
                                                    _vm._s(
                                                      item.thirdPartyOrderCreateTime
                                                    )
                                                )
                                              ]
                                            )
                                          ]
                                        : item.syncStatus == "2"
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text mar10-b item"
                                              },
                                              [
                                                _vm._v(
                                                  "失败原因: " +
                                                    _vm._s(item.syncMsg)
                                                )
                                              ]
                                            )
                                          ]
                                        : item.syncStatus == "3"
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text mar10-b item"
                                              },
                                              [
                                                _vm._v(
                                                  "无响应状态为对方系统未返回同步结果，请尝试手动同步或联系系统开发者查询具体原因"
                                                )
                                              ]
                                            )
                                          ]
                                        : [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text mar10-b item"
                                              },
                                              [
                                                _vm._v(
                                                  "三方订单正在同步生成中，可刷新页面获取最新结果"
                                                )
                                              ]
                                            )
                                          ]
                                    ],
                                    2
                                  ),
                                  item.syncStatus == "2" ||
                                  item.syncStatus == "3"
                                    ? _c(
                                        "div",
                                        { staticClass: "text-right" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "medium"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.manualSync(item)
                                                }
                                              }
                                            },
                                            [_vm._v("手动同步")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ])
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c("div", { staticClass: "text-center pad20 pad40-t" }, [
                _vm._v("暂无数据")
              ]),
          _vm.list && _vm.list.length
            ? _c(
                "div",
                { staticClass: "flex justify-end pad20-t" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "prev, pager, next",
                      total: _vm.total
                    },
                    on: { "current-change": _vm.currentChange }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }